module.exports = __webpack_public_path__ + "fonts/Averta-Bold.7e812b1.eot";